import { render, staticRenderFns } from "./WorkflowFormStateAvailableAssigneePicker.vue?vue&type=template&id=8b3705d4&"
import script from "./WorkflowFormStateAvailableAssigneePicker.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormStateAvailableAssigneePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports